export enum Colors {
    Reinorange = "#FB471F",
    Reinrot = "#C91235",
    Anthrazitgrau = "#333F4C",
    Telegrau2 = "#7C8795",
    Telegrau4 = "#C0C6D6"
}